var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.orderInvalidAccess)?_c('div',[_c('router-view')],1):_c('v-container',[_c('picker-order-invalid-access')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }